import { BehaviorSubject } from 'rxjs';

export default class RegisterBloc {
  isRegistering$ = new BehaviorSubject(false);
  values$ = new BehaviorSubject({
    isButtonEnabled() {
      return this.termsCheck;
    },
    termsCheck: false,
  });

  constructor({ authRepository }) {
    this.authRepository = authRepository;
  }

  async register(data) {
    this.isRegistering$.next(true);
    try {
      await this.authRepository.register(data);
    } finally {
      this.isRegistering$.next(false);
    }
  }

  onValuesChange(value, target) {
    const currentVal = { ...this.values$.getValue() };
    currentVal[target] = value;

    this.values$.next(currentVal);
  }
}
